
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/clients?${queryString}`);
    return response.data;
  },

  async getById(id) {
    const response = await https.get(`/clients/${id}`);
    return response.data.data;
  },

  async add(payload) {
    const response = await https.post(`/clients`, payload);
    return response.data;
  },
   async importClient(payload) {
    const response = await https.post(`/clients-import`, payload);
    return response.data;
  },



  async update(id, payload) {
    console.log(payload,'payload')
    const response = await https.post(`/clients/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/clients/${id}`);
    return response.data;
  },
});
